<!-- common certificate -->

<template>
  <div class="common-certificate">
    <!-- ip360证书 -->
    <div v-if="queryInfo.partnerId==1 && this.certApply != 'Xcontract'">
      <div class="certificate-see" v-html="htmls"></div>
    </div>
    <!-- 钱唐证书 -->
    <div v-else-if="queryInfo.partnerId==2">
      <div class="see_qt" v-if="certificate.list.version == 2 ||certificate.list.version == 1">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <!-- <div class="introduce">本证书由真相数据保全中心，杭州互联网公证处联合签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div> -->
        <div class="abstract clearfix" style="top: 128px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 165px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 115px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>保管机构：</span>
          <span>浙江省杭州市杭州互联网公证处</span>
        </div>
        <div class="introduce" style=" margin-top: 5px;" v-if="certificate.list.productType == 1">
          根据上述信息，兹证明：申请人已将相应的电子证据保管至本处。
        </div>
        <div class="introduce" style=" margin-top: 5px;" v-else>根据上述信息，兹证明：申请人已通过本处系统取得相应的电子证据并保管至本处。</div>
        <div class="introduce" style="color: #6c838b;">
          特别提示：本文件仅系电子证据保管时所自动生成的信息汇集反馈，并不直接作为本机构出具的证明文书。如您需要公证机构对电子证据的相关信息作出证明的，敬请提出公证申请。本机构在审查后将依法决定是否出具公证书。
        </div>
        <!-- <div class="issue">
            <p style="font-weight: bold;">证书签发机构</p>
            <p style="color: #999;">杭州互联网公证处</p>
          </div> -->
        <span class="QRCode">
            <img :src="certificate.list.QRCodeUrl">
          </span>
      </div>
      <div class="new_see_qt" v-if="certificate.list.version == 0">
        <div class="title" v-html="keyList.title"></div>
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <!-- <div class="introduce" style="width: 365px;">本证书由真相数据保全中心，北京网络行业协会电子数据司法鉴定中心联合签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div> -->
        <div class="issue" style="width: 365px;margin: 10px auto;">
          <p>证书签发机构： 真相数据保全中心、</p>
          <p style="margin: 5px 0px 0px 88px;">北京网络行业协会电子数据司法鉴定中心</p>
        </div>
        <div class="abstract clearfix" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <span class="QRCode">
            <img :src="certificate.list.QRCodeUrl">
          </span>
      </div>
    </div>

    <!-- 广州证书 -->
    <div v-else-if="queryInfo.partnerId==3">
      <!-- V3 -->
      <div class="see_new_gz" v-if="certificate.list.version == 2">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">广州市海珠公证处</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
      <!-- V2 -->
      <div class="see_gz" v-if="certificate.list.version == 3">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由真相数据保全中心，北京网络行业协会电子数据司法鉴定中心联合签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 193px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 233px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 120px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p>真相数据保全中心</p>
          <p>北京网络行业协会电子数据司法鉴定中心</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
      <!-- V1 -->
      <div class="new_see_gz" v-if="certificate.list.version == 1">
        <div class="title" v-html="keyList.title"></div>
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce" style="width: 365px;">
          本证书由真相数据保全中心，北京网络行业协会电子数据司法鉴定中心联合签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。
        </div>
        <div class="issue" style="width: 365px;margin: 10px auto;">
          <p>证书签发机构： 真相数据保全中心、</p>
          <p style="margin: 5px 0px 0px 88px;">北京网络行业协会电子数据司法鉴定中心</p>
        </div>
        <div class="abstract clearfix" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
    </div>

    <!-- 内蒙 -->
    <div v-else-if="queryInfo.partnerId==4">
      <div class="see_nm" v-if="certificate.list.version == 2 ||certificate.list.version == 1">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由真相数据保全中心，广州市海珠公证处联合签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 220px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 135px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p>真相数据保全中心</p>
          <p>广州市海珠公证处</p>
        </div>
        <!-- <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span> -->
      </div>
      <div class="new_see_nm" v-else>
        <div class="title" v-html="keyList.title"></div>
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce" style="width: 365px;">
          本证书由真相数据保全中心，北京网络行业协会电子数据司法鉴定中心联合签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。
        </div>
        <div class="issue" style="width: 365px;margin: 10px auto;">
          <p>证书签发机构： 真相数据保全中心、</p>
          <p style="margin: 5px 0px 0px 88px;">北京网络行业协会电子数据司法鉴定中心</p>
        </div>
        <div class="abstract clearfix" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <!-- <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span> -->
      </div>
    </div>

    <!-- 方正 -->
    <div v-else-if="queryInfo.partnerId==5">
      <!-- v4 -->
      <div class="see_new_four_fz" v-if="certificate.list.version == 2">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">北京市方正公证处</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
      <!-- V3 -->
      <div class="see_new_fz" v-if="certificate.list.version == 3">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">北京市方正公证处</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
      <!-- V2 -->
      <div class="see_fz" v-if="certificate.list.version == 4">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由真相数据保全中心，北京网络行业协会电子数据司法鉴定中心联合签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 137px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 168px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 110px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">北京市方正公证处</p>
        </div>
        <span class="QRCode">
              <img :src="certificate.list.QRCodeUrl">
            </span>
      </div>
      <!-- V1 -->
      <div class="new_see_fz" v-if="certificate.list.version == 0">
        <div class="title" v-html="keyList.title"></div>
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce" style="width: 365px;">
          本证书由真相数据保全中心，北京网络行业协会电子数据司法鉴定中心联合签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。
        </div>
        <div class="issue" style="width: 365px;margin: 10px auto;">
          <p>证书签发机构： 真相数据保全中心、</p>
          <p style="margin: 5px 0px 0px 88px;">北京网络行业协会电子数据司法鉴定中心</p>
        </div>
        <div class="abstract clearfix" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
    </div>

    <!-- 华东 -->
    <div v-else-if="queryInfo.partnerId==6">
      <!-- V3 -->
      <div class="see_new_wz" v-if="certificate.list.version == 2">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 120px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">浙江省温州市华东公证处</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
      <!-- V2 -->
      <div class="see_wz" v-if="certificate.list.version == 3">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由真相数据保全中心，北京网络行业协会电子数据司法鉴定中心联合签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 193px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 233px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 120px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p>真相数据保全中心</p>
          <p>北京网络行业协会电子数据司法鉴定中心</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
      <!-- V1 -->
      <div class="new_see_wz" v-if="certificate.list.version == 1">
        <div class="title" v-html="keyList.title"></div>
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce" style="width: 365px;">
          本证书由真相数据保全中心，北京网络行业协会电子数据司法鉴定中心联合签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。
        </div>
        <div class="issue" style="width: 365px;margin: 10px auto;">
          <p>证书签发机构： 真相数据保全中心、</p>
          <p style="margin: 5px 0px 0px 88px;">北京网络行业协会电子数据司法鉴定中心</p>
        </div>
        <div class="abstract clearfix" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
    </div>

    <!-- 渤海证书 -->
    <div v-else-if="queryInfo.partnerId==7">
      <!-- V3 -->
      <div class="see_new_bh" v-if="certificate.list.version == 2">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">河北省沧州市渤海公证处</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
      <!-- V2 -->
      <div class="see_bh" v-if="certificate.list.version == 3">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由真相数据保全中心，北京网络行业协会电子数据司法鉴定中心联合签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 193px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 233px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 120px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p>真相数据保全中心</p>
          <p>北京网络行业协会电子数据司法鉴定中心</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
      <!-- V1 -->
      <div class="new_see_bh" v-if="certificate.list.version == 1">
        <div class="title" v-html="keyList.title"></div>
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce" style="width: 365px;">
          本证书由真相数据保全中心，北京网络行业协会电子数据司法鉴定中心联合签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。
        </div>
        <div class="issue" style="width: 365px;margin: 10px auto;">
          <p>证书签发机构： 真相数据保全中心、</p>
          <p style="margin: 5px 0px 0px 88px;">北京网络行业协会电子数据司法鉴定中心</p>
        </div>
        <div class="abstract clearfix" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 5px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
    </div>
    <!-- 佛山 -->
    <div v-else-if="queryInfo.partnerId==8">
      <!-- v4 -->
      <div :class="certificate.list.productType==1?'see_new_four_fs_right':'see_new_four_fs'"
           v-if="certificate.list.version == 2">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">佛山市版权保护协会</p>
        </div>
        <span class="QRCode">
        <img :src="certificate.list.QRCodeUrl">
      </span>
      </div>
    </div>


    <!-- 安顿证书 -->
    <div v-else-if="queryInfo.partnerId==9">
      <!-- V3 -->
      <div class="see_new_ad">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">安盾网</p>
        </div>
        <!-- <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span> -->
      </div>
    </div>

    <!-- 方圆证书 -->
    <div v-else-if="queryInfo.partnerId==11">
      <!-- v4 -->
      <div class="see_new_four_fy">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">北京市方圆公证处</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
    </div>

    <!-- 精诚证书 -->
    <div v-else-if="queryInfo.partnerId==10">
      <div class="jc-common-certificate">
        <!-- V3 -->
        <div class="jc-see_new_four">
          <div class="title" v-html="keyList.title"></div>
          <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
          <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
            {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
          </div>
          <div class="detail-line detail-lines" v-if="certificate.list.txId && certificate.list.txId != ''">
            <span>{{ keyList.txId }}：</span>
            <span>{{ certificate.list.txId }}</span>
          </div>
          <div class="detail-line detail-lines" v-if="certificate.list.sha512 && certificate.list.sha512 != ''">
            <span>{{ keyList.sha512 }}：</span>
            <span>{{ certificate.list.sha512 }}</span>
          </div>
          <div class="detail-line" style="margin-top:45px;" :class="{'null-data': !certificate.list.ower}">
            <span>{{ keyList.ower }}：</span>
            <span>{{ certificate.list.ower }}</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;"
               v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
            <span>{{ keyList.evideceName }}：</span>
            <span>{{ certificate.list.evideceName }}</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;"
               v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
            <span>{{ keyList.evideceWay }}：</span>
            <span>{{ certificate.list.evideceWay }}</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;"
               v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
            <span>{{ keyList.evideceType }}：</span>
            <span>{{ certificate.list.evideceType }}</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;"
               v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
            <span>{{ keyList.evideceTime }}：</span>
            <span>{{ certificate.list.evideceTime }}</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
            <span>{{ keyList.callerNumber }}：</span>
            <span>{{ certificate.list.callerNumber }}</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
            <span>{{ keyList.calleeNumber }}：</span>
            <span>{{ certificate.list.calleeNumber }}</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;"
               v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
            <span>{{ keyList.evideceLocation }}：</span>
            <span>{{ certificate.list.evideceLocation }}</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;"
               v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
            <span>{{ keyList.evideceImei }}：</span>
            <span>{{ certificate.list.evideceImei }}</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;"
               v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
            <span>{{ keyList.evideceUrl }}：</span>
            <span>{{ certificate.list.evideceUrl }}</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;"
               v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
            <span>{{ keyList.evideceSize }}：</span>
            <span>{{ certificate.list.evideceSize }}</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;"
               v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
            <span>{{ keyList.evideceFormat }}：</span>
            <span>{{ certificate.list.evideceFormat }}</span>
          </div>
          <div class="jc-introduce">
            <p>兹证明申请人{{ certificate.list.ower }}已通过本处电子数据存证系统取得相应的电子数据并提交本处保管，上述信息系电子数据保管时所自动生成的信息汇总。</p>
            <p>经验证，该电子数据自提交本处保管之时起未经篡改。</p>
          </div>
          <div class="jc-issue">
            <p>北京市精诚公证处</p>
            <p>{{ format(certificate.list.evideceTime, 1) }}</p>
          </div>
          <span class="jc-QRCode">
            <img :src="certificate.list.QRCodeUrl">
          </span>
        </div>

      </div>
    </div>
    <!-- 国立证书 -->
    <div v-else-if="queryInfo.partnerId==12">
      <!-- v4 -->
      <div class="see_new_four_cdgl">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">四川省成都市国力公证处</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
    </div>

    <div v-else-if="queryInfo.partnerId==13 && this.certApply != 'gzfq'">
      <!-- v4 -->
      <div class="see_new_four_gzfq">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">广东省广州市公证处</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
    </div>

    <!-- 大成证书 -->
    <div v-else-if="queryInfo.partnerId==14">
      <div class="see_new_four_dc">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.productType ==4">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.productType ==4">
          <span>{{ keyList.checkStatus }}：</span>
          <span>{{ certificate.list.checkStatus }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''&& certificate.list.type!==6 && certificate.list.productType !=4">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <!-- 手机序列号 -->
        <!-- <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==6 ">
            <span>{{keyList.evideceImei}}：</span>
            <span>{{certificate.list.evideceImei}}</span>
          </div> -->
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != '' && certificate.list.summary ">
          <span>{{ keyList.evideceSize }}：</span>
          <span style=" width: 80px;">{{ certificate.list.evideceSize }}</span>
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''&& !certificate.list.summary">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''&& !certificate.list.summary">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>

        <div class="detail-line" style="margin-top: 3px;" v-if=" certificate.list.summary ">
          <span>{{ keyList.summary }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-for="(value, name ,index) in certificate.list.summary"
             :key='index'>
          <span>{{ name }}：</span>
          <span>{{ value }}</span>
        </div>
        <!-- <div class="detail-line" style="margin-top: 3px;">
            <span>监测位置：</span>
            <span>服气、400、200M</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;">
            <span>监测时间：</span>
            <span>服气、400、200M</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;">
            <span>监测频率：</span>
            <span>服气、400、200M</span>
          </div> -->
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">江西省南昌市大成公证处</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
    </div>

    <!-- 辰信证书 -->
    <div v-else-if="queryInfo.partnerId==16">
      <div class="see_new_four_cx">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.productType ==4">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.productType ==4">
          <span>{{ keyList.checkStatus }}：</span>
          <span>{{ certificate.list.checkStatus }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''&& certificate.list.type!==6 && certificate.list.productType !=4">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <!-- 手机序列号 -->
        <!-- <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==6 ">
            <span>{{keyList.evideceImei}}：</span>
            <span>{{certificate.list.evideceImei}}</span>
          </div> -->
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != '' && certificate.list.summary ">
          <span>{{ keyList.evideceSize }}：</span>
          <span style=" width: 80px;">{{ certificate.list.evideceSize }}</span>
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''&& !certificate.list.summary">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''&& !certificate.list.summary">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>

        <div class="detail-line" style="margin-top: 3px;" v-if=" certificate.list.summary ">
          <span>{{ keyList.summary }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-for="(value, name ,index) in certificate.list.summary"
             :key='index'>
          <span>{{ name }}：</span>
          <span>{{ value }}</span>
        </div>
        <!-- <div class="detail-line" style="margin-top: 3px;">
            <span>监测位置：</span>
            <span>服气、400、200M</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;">
            <span>监测时间：</span>
            <span>服气、400、200M</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;">
            <span>监测频率：</span>
            <span>服气、400、200M</span>
          </div> -->
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">天津市辰信公证处</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
    </div>

    <!-- IP360华为云证书 -->
    <div v-else-if="queryInfo.partnerId==15">
      <div class="see_new_four">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.productType ==4">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.productType ==4">
          <span>{{ keyList.checkStatus }}：</span>
          <span>{{ certificate.list.checkStatus }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''&& certificate.list.type!==6 && certificate.list.productType !=4">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <!-- 手机序列号 -->
        <!-- <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==6 ">
            <span>{{keyList.evideceImei}}：</span>
            <span>{{certificate.list.evideceImei}}</span>
          </div> -->
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != '' && certificate.list.summary ">
          <span>{{ keyList.evideceSize }}：</span>
          <span style=" width: 80px;">{{ certificate.list.evideceSize }}</span>
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''&& !certificate.list.summary">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''&& !certificate.list.summary">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>

        <div class="detail-line" style="margin-top: 3px;" v-if=" certificate.list.summary ">
          <span>{{ keyList.summary }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-for="(value, name ,index) in certificate.list.summary"
             :key='index'>
          <span>{{ name }}：</span>
          <span>{{ value }}</span>
        </div>
        <!-- <div class="detail-line" style="margin-top: 3px;">
            <span>监测位置：</span>
            <span>服气、400、200M</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;">
            <span>监测时间：</span>
            <span>服气、400、200M</span>
          </div>
          <div class="detail-line" style="margin-top: 3px;">
            <span>监测频率：</span>
            <span>服气、400、200M</span>
          </div> -->
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">IP360华为云</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
    </div>


    <!-- 电子签约证书 -->
    <div v-else-if="this.certApply == 'Xcontract'" class="xcon-cert">
      <div class="xcon-file-block">
        <el-tabs v-model="activeName" type="card" @tab-click="activeChange">
          <el-tab-pane
              v-for="(item,index) in xconFileList"
              :key="index"
              :name="item.id"
              :url="item.filePath"
              :item="item"
          >
            <span slot="label"><i :class="{'active-default': queryInfo.contractFileId == item.id}"></i> {{ item.fileName }}</span>
            <div class="xcon-cert-box">
              <div class="contentContainer" v-if="item.cert">
                <div class="proFlag"></div>
                <div class="proTitle">Xcontract电子签约保全证书</div>
                <div class="proId">证书编号：{{ item.cert ? item.cert.certificateCode : '' }}</div>
                <div class="proDscp">
                  本证书由司法联盟链legalXchain签发，证明文件（电子数据）自电子签约发起
                  至签署完成，已经存在且内容保持完整，未被修改。
                </div>
                <div class="proIdList">
                  <div class="item" style="margin-bottom: 20px;">
                    <div class="label">合同指纹HASH:</div>
                    <div class="content">{{ item.cert ? item.cert.fileHash : ''}}</div>
                  </div>
                  <div class="item">
                    <div class="label">区块链保全ID：</div>
                    <div class="content">{{ item.cert ? item.cert.txId : '' }}</div>
                  </div>
                </div>
                <div class="proIdList formItem" v-if="item.cert && item.cert.contract">
                  <div class="item">
                    <div class="label">合同名称：</div>
                    <div class="content">{{ item.cert.contract.name }}</div>
                  </div>
                  <div class="item">
                    <div class="label">签署截止日期：</div>
                    <div class="content">{{ $moment(item.cert.contract.signDeadlineDate).format("YYYY-MM-DD") }}</div>
                  </div>
                  <div class="item">
                    <div class="label">合同有效期限：</div>
                    <div class="content">{{ $moment(item.cert.contract.startDate).format("YYYY-MM-DD") }} 至
                      {{ $moment(item.cert.contract.endDate).format("YYYY-MM-DD") }}
                    </div>
                  </div>
                  <div class="item">
                    <div class="label">发起方：</div>
                    <div class="content">{{ item.cert.contractUser.name }}</div>
                  </div>
                  <div class="item">
                    <div class="label">发起签约时间：</div>
                    <div class="content">{{ $moment(item.cert.contract.signStartTime).format("YYYY-MM-DD") }}</div>
                  </div>
                  <div class="item">
                    <div class="label">签署方：</div>
                    <div class="content">{{ getSignUser(item.cert.signatoryList) }}</div>
                  </div>
                  <div class="item">
                    <div class="label">签署完成时间：</div>
                    <div class="content">{{ $moment(item.cert.contract.signFinishTime).format("YYYY-MM-DD") }}</div>
                  </div>
                  <div class="item">
                    <div class="label">签署平台：</div>
                    <div class="content">Xcontract</div>
                  </div>
                  <div class="item">
                    <div class="label">顺序签署：</div>
                    <div class="content" v-if="item.cert.contract.orderType==1">是</div>
                    <div class="content" v-if="item.cert.contract.orderType==0">否</div>
                  </div>
                  <div class="item">
                    <div class="label">时间戳：</div>
                    <div class="content">国家授时中心北斗卫星授时</div>
                  </div>
                  <div class="item">
                    <div class="label">证书签发机构：</div>
                    <div class="content">司法联盟链legalXchain</div>
                  </div>
                  <div class="item">
                    <div class="label">文件大小：</div>
                    <div class="content">{{ item.cert.fileSize }}</div>
                  </div>
                  <div class="item">
                    <div class="label">文件格式：</div>
                    <div class="content">.PDF</div>
                  </div>
                  <div class="seaImage"></div>
                </div>

                <div class="bottomDetail">
                  <div class="qrcodeBox">
                    <vue-qr id="qrcode" :text="item.codeValue ? item.codeValue : ''"></vue-qr>
                    <p class="qrcodeDscp">扫码手机端查看</p>
                  </div>
                  <div class="sealPower"></div>
                </div>
              </div>
              <div :id="item.id" class="xcon-cert-item"></div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 赋强证书 -->
    <div v-else-if="this.certApply == 'gzfq'" class="fq-sass-cert">

      <div class="xcon-file-block">
        <el-tabs v-model="activeName" type="card" @tab-click="activeChange">
          <el-tab-pane
              v-for="(item,index) in xconFileList"
              :key="index"
              :name="item.id"
              :url="item.filePath"
              :item="item"
          >
            <span slot="label"><i :class="{'active-default': queryInfo.contractFileId == item.id}"></i> {{ item.fileName }}</span>
            <div class="xcon-cert-box">
              <div class="contentContainer" v-if="item.cert">
                <div class="proTitle">电子签约保全证书</div>
                <div class="proId">证书编号：{{ item.cert.certificateCode }}</div>
                <div class="proDscp">
                  本证书由司法联盟链legalXchain签发，证明文件（电子数据）自电子签约发起
                  至签署完成，已经存在且内容保持完整，未被修改。
                </div>
                <div class="proIdList proIdNumber">
                  <div class="item">
                    <div class="label">合同指纹HASH:</div>
                    <div class="content">{{ item.cert.fileHash }}</div>
                  </div>
                  <div class="item">
                    <div class="label">区块链保全ID：</div>
                    <div class="content">{{ item.cert.txId }}</div>
                  </div>
                </div>
                <div class="proIdList formItem" v-if="item.cert.contract">
                  <div class="item">
                    <div class="label">合同名称：</div>
                    <div class="content">{{ item.cert.contract.name }}</div>
                  </div>
                  <div class="item">
                    <div class="label">签署截止日期：</div>
                    <div class="content">{{ $moment(item.cert.contract.signDeadlineDate).format("YYYY-MM-DD") }}</div>
                  </div>
                  <div class="item">
                    <div class="label">合同有效期限：</div>
                    <div class="content">{{ $moment(item.cert.contract.startDate).format("YYYY-MM-DD") }} 至
                      {{ $moment(item.cert.contract.endDate).format("YYYY-MM-DD") }}
                    </div>
                  </div>
                  <div class="item">
                    <div class="label">发起方：</div>
                    <div class="content">{{ item.cert.contractUser.name }}</div>
                  </div>
                  <div class="item">
                    <div class="label">发起签约时间：</div>
                    <div class="content">{{ $moment(item.cert.contract.signStartTime).format("YYYY-MM-DD") }}</div>
                  </div>
                  <div class="item">
                    <div class="label">签署方：</div>
                    <div class="content">{{ getSignUser(item.cert.signatoryList) }}</div>
                  </div>
                  <div class="item">
                    <div class="label">签署完成时间：</div>
                    <div class="content">{{ $moment(item.cert.contract.signFinishTime).format("YYYY-MM-DD") }}</div>
                  </div>
                  <div class="item">
                    <div class="label">签署平台：</div>
                    <div class="content">广州公证处区块链赋强公证系统</div>
                  </div>
                  <div class="item">
                    <div class="label">顺序签署：</div>
                    <div class="content" v-if="item.cert.contract.orderType==1">是</div>
                    <div class="content" v-if="item.cert.contract.orderType==0">否</div>
                  </div>
                  <div class="item">
                    <div class="label">时间戳：</div>
                    <div class="content">国家授时中心北斗卫星授时</div>
                  </div>
                  <div class="item">
                    <div class="label">证书签发机构：</div>
                    <div class="content">广东省广州市广州公证处</div>
                  </div>
                  <div class="item">
                    <div class="label">文件大小：</div>
                    <div class="content">{{ item.cert.fileSize }}</div>
                  </div>
                  <div class="item">
                    <div class="label">文件格式：</div>
                    <div class="content">.PDF</div>
                  </div>
                </div>

                <div class="bottomDetail">
                  <div class="qrcodeBox">
                    <vue-qr id="qrcode" :text="item.codeValue"></vue-qr>
                    <p class="qrcodeDscp">手机端<br>扫码查看</p>
                  </div>
                  <div class="sealPower">
                    <div class="seal-item"></div>
                    <div class="seal-title-h1">证书签发机构</div>
                    <div class="seal-title-h2">司法联盟链</div>
                  </div>
                  <div class="sealFq">
                    <div class="seal-item"></div>
                    <div class="seal-title-h1">证书签发节点</div>
                    <div class="seal-title-h2">广东省广州市广州公证处</div>
                  </div>
                </div>
              </div>
              <div :id="item.id" class="xcon-cert-item"></div>
            </div>

          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 上海东方 -->
    <div v-else-if="queryInfo.partnerId==21">
      <div class="see_new_four_df">
        <div class="title" v-html="keyList.title"></div>
        <!-- v-show="!(certificate.list.certificateNum && certificate.list.certificateNum != '')" -->
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">上海市东方公证处电子存证专用节点</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
    </div>
    <!-- 对接调解平台证书模板-->
    <div v-else-if="queryInfo.partnerId==23">
      <!-- <template v-if="queryInfo.type==2"> -->
        <div class="certificate_tj">
          <div class="certificate_title">
            {{ tjTitles[queryInfo.type].name }}
          </div>
          <div class="certificate-number">
            {{ keyList.certNo }}：{{ certificate.list.certNo }}
          </div>
          <div class="introduce">
            本证书由司法联盟链legalXchain签发，证明电子送达文件自发起送达起已经存在且内容保持完整，未被篡改。
          </div>
          <div class="hash-box">
            <div class="message message-no-margin">
              <div class="text">{{ keyList.fileHash }}：</div>
              <div class="value">{{ certificate.list.fileHash }}</div>
            </div>
            <div class="message message-no-margin">
              <div class="text">{{ keyList.chainId }}：</div>
              <div class="value">{{ certificate.list.chainId }}</div>
            </div>
          </div>

          <div class="message">
            <div class="text">{{ keyList.fileName }}：</div>
            <div class="value">{{ certificate.list.fileName }}</div>
          </div>
          <div class="message">
            <div class="text">{{ keyList.fileName }}：</div>
            <div class="value">{{ certificate.list.fileSize }}</div>
          </div>
          <div class="message">
            <div class="text">{{ keyList.fileName }}：</div>
            <div class="value">{{ certificate.list.fileType }}</div>
          </div>
          <!-- 送达文书 -->
          <template v-if="certificate.list.type==2">
            <div class="message">
              <div class="text">{{ keyList.sendName }}：</div>
              <div class="value">{{ certificate.list.sendName }}</div>
            </div>
            <div class="message">
              <div class="text">{{ keyList.sendTime }}：</div>
              <div class="value">{{ certificate.list.sendTime }}</div>
            </div>
            <div class="message">
              <div class="text">{{ keyList.deliverName }}：</div>
              <div class="value">{{ certificate.list.deliverName }}</div>
            </div>
          </template>
          <!-- 调解视频 -->
          <template v-if="certificate.list.type === 3">
            <div class="message">
              <div class="text">{{ keyList.videoParticipant }}：</div>
              <div class="value">{{ certificate.list.videoParticipant }}</div>
            </div>
            <div class="message">
              <div class="text">{{ keyList.videoRealTime }}：</div>
              <div class="value">{{ certificate.list.videoRealTime }}</div>
            </div>
            <div class="message">
              <div class="text">{{ keyList.videoDuration }}：</div>
              <div class="value">{{ certificate.list.videoDuration }}</div>
            </div>
          </template>
          <!-- 呼叫录音 -->
          <template v-if="certificate.list.type === 6">
            <div class="message">
              <div class="text">{{ keyList.callName }}：</div>
              <div class="value">{{ certificate.list.callName }}</div>
            </div>
            <div class="message">
              <div class="text">{{ keyList.callTime }}：</div>
              <div class="value">{{ certificate.list.callTime }}</div>
            </div>
            <div class="message">
              <div class="text">{{ keyList.callDuration }}：</div>
              <div class="value">{{ certificate.list.callDuration }}</div>
            </div>
          </template>
          <div class="message">
            <div class="text">{{ keyList.chainTime }}：</div>
            <div class="value">{{ certificate.list.chainTime }}</div>
          </div>
          <div class="message">
            <div class="text">时间戳：</div>
            <div class="value">国家授时中心北斗卫星授时</div>
          </div>
          <div class="message">
            <div class="text">{{ keyList.chainOrgName }}：</div>
            <div class="value">{{ certificate.list.chainOrgName }}</div>
          </div>
          <div class="message">
            <div class="text">{{ keyList.chainNodeName }}：</div>
            <div class="value">{{ certificate.list.chainNodeName }}</div>
          </div>

          <div class="issue">
            <div class="img-box">
              <img :src="certificate.list.sealFileUrl" alt="" />
            </div>
            <div class="name">{{ certificate.list.chainNodeName }}</div>
          </div>

          <div class="qrcode">
            <div class="img-box">
              <img :src="certificate.list.QRCodeUrl" alt="" />
            </div>
          </div>
        </div>
      <!-- </template>
      调解视频
      <template v-else-if="queryInfo.type==3">
      </template>
      呼叫录音
      <template v-else-if="queryInfo.type==6">
      </template> -->
    </div>   
    <!-- 河南事务中心 -->
    <div v-else-if="queryInfo.partnerId==25">
      <div class="see_new_four_hnswzx">
        <div class="title" v-html="keyList.title"></div>
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">河南公平竞争审查事务中心</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
    </div>
     <!-- 鞍山立山公证处 -->
     <div v-else-if="queryInfo.partnerId==26">
      <div class="see_new_four_asls">
        <div class="title" v-html="keyList.title"></div>
        <div class="certificate-number" :class="{'null-data': !certificate.list.certificateNum}">
          {{ keyList.certificateNum }}：{{ certificate.list.certificateNum }}
        </div>
        <div class="introduce">本证书由司法联盟链legalXchain区块链系统签发，证明文件（电子数据）自申请时间起已经存在且内容保持完整，未被篡改。</div>
        <div class="abstract clearfix" style="top: 145px;" :class="{'null-data': !certificate.list.txId}">
          <span>{{ keyList.txId }}：</span>
          <span>{{ certificate.list.txId }}</span>
        </div>
        <div class="abstract clearfix" style="top: 180px;" :class="{'null-data': !certificate.list.sha512}">
          <span>{{ keyList.sha512 }}：</span>
          <span>{{ certificate.list.sha512 }}</span>
        </div>
        <div class="detail-line" style="margin-top: 96px;" :class="{'null-data': !certificate.list.ower}">
          <span>{{ keyList.ower }}：</span>
          <span>{{ certificate.list.ower }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceName && certificate.list.evideceName != ''">
          <span>{{ keyList.evideceName }}：</span>
          <span>{{ certificate.list.evideceName }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceWay && certificate.list.evideceWay != ''">
          <span>{{ keyList.evideceWay }}：</span>
          <span>{{ certificate.list.evideceWay }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceType && certificate.list.evideceType != ''">
          <span>{{ keyList.evideceType }}：</span>
          <span>{{ certificate.list.evideceType }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceTime && certificate.list.evideceTime != ''">
          <span>{{ keyList.evideceTime }}：</span>
          <span>{{ certificate.list.evideceTime }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.callerNumber }}：</span>
          <span>{{ certificate.list.callerNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;" v-if="certificate.list.type==50004 ">
          <span>{{ keyList.calleeNumber }}：</span>
          <span>{{ certificate.list.calleeNumber }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceLocation && certificate.list.evideceLocation != ''">
          <span>{{ keyList.evideceLocation }}：</span>
          <span>{{ certificate.list.evideceLocation }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceImei && certificate.list.evideceImei != ''">
          <span>{{ keyList.evideceImei }}：</span>
          <span>{{ certificate.list.evideceImei }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceUrl && certificate.list.evideceUrl != ''">
          <span>{{ keyList.evideceUrl }}：</span>
          <span>{{ certificate.list.evideceUrl }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceSize && certificate.list.evideceSize != ''">
          <span>{{ keyList.evideceSize }}：</span>
          <span>{{ certificate.list.evideceSize }}</span>
        </div>
        <div class="detail-line" style="margin-top: 3px;"
             v-if="certificate.list.evideceFormat && certificate.list.evideceFormat != ''">
          <span>{{ keyList.evideceFormat }}：</span>
          <span>{{ certificate.list.evideceFormat }}</span>
        </div>
        <div class="issue">
          <p style="font-weight: bold;">证书签发机构</p>
          <p style="color:#767676">司法联盟链</p>
          <p style="font-weight: bold;">证书签发节点</p>
          <p style="color:#767676">鞍山市立山区公证</p>
        </div>
        <span class="QRCode">
          <img :src="certificate.list.QRCodeUrl">
        </span>
      </div>
    </div>
    <!-- 对接金法 SaaS 调解平台证书模板-->
    <div v-else-if="queryInfo.partnerId==27">
      <!-- <template v-if="queryInfo.type==2"> -->
        <div class="certificate_tj">
          <div class="certificate_title">
            {{ tjTitles[queryInfo.type].name }}
          </div>
          <div class="certificate-number">
            {{ keyList.certNo }}：{{ certificate.list.certNo }}
          </div>
          <div class="introduce">
            本证书由司法联盟链legalXchain签发，证明电子送达文件自发起送达起已经存在且内容保持完整，未被篡改。
          </div>
          <div class="hash-box">
            <div class="message message-no-margin">
              <div class="text">{{ keyList.fileHash }}：</div>
              <div class="value">{{ certificate.list.fileHash }}</div>
            </div>
            <div class="message message-no-margin">
              <div class="text">{{ keyList.chainId }}：</div>
              <div class="value">{{ certificate.list.chainId }}</div>
            </div>
          </div>

          <div class="message">
            <div class="text">{{ keyList.fileName }}：</div>
            <div class="value">{{ certificate.list.fileName }}</div>
          </div>
          <div class="message">
            <div class="text">{{ keyList.fileName }}：</div>
            <div class="value">{{ certificate.list.fileSize }}</div>
          </div>
          <div class="message">
            <div class="text">{{ keyList.fileName }}：</div>
            <div class="value">{{ certificate.list.fileType }}</div>
          </div>
          <!-- 送达文书 -->
          <template v-if="certificate.list.type==2">
            <div class="message">
              <div class="text">{{ keyList.sendName }}：</div>
              <div class="value">{{ certificate.list.sendName }}</div>
            </div>
            <div class="message">
              <div class="text">{{ keyList.sendTime }}：</div>
              <div class="value">{{ certificate.list.sendTime }}</div>
            </div>
            <div class="message">
              <div class="text">{{ keyList.deliverName }}：</div>
              <div class="value">{{ certificate.list.deliverName }}</div>
            </div>
          </template>
          <!-- 调解视频 -->
          <template v-if="certificate.list.type === 3">
            <div class="message">
              <div class="text">{{ keyList.videoParticipant }}：</div>
              <div class="value">{{ certificate.list.videoParticipant }}</div>
            </div>
            <div class="message">
              <div class="text">{{ keyList.videoRealTime }}：</div>
              <div class="value">{{ certificate.list.videoRealTime }}</div>
            </div>
            <div class="message">
              <div class="text">{{ keyList.videoDuration }}：</div>
              <div class="value">{{ certificate.list.videoDuration }}</div>
            </div>
          </template>
          <!-- 呼叫录音 -->
          <template v-if="certificate.list.type === 6">
            <div class="message">
              <div class="text">{{ keyList.callName }}：</div>
              <div class="value">{{ certificate.list.callName }}</div>
            </div>
            <div class="message">
              <div class="text">{{ keyList.callTime }}：</div>
              <div class="value">{{ certificate.list.callTime }}</div>
            </div>
            <div class="message">
              <div class="text">{{ keyList.callDuration }}：</div>
              <div class="value">{{ certificate.list.callDuration }}</div>
            </div>
          </template>
          <div class="message">
            <div class="text">{{ keyList.chainTime }}：</div>
            <div class="value">{{ certificate.list.chainTime }}</div>
          </div>
          <div class="message">
            <div class="text">时间戳：</div>
            <div class="value">国家授时中心北斗卫星授时</div>
          </div>
          <div class="message">
            <div class="text">{{ keyList.chainOrgName }}：</div>
            <div class="value">{{ certificate.list.chainOrgName }}</div>
          </div>
          <div class="message">
            <div class="text">{{ keyList.chainNodeName }}：</div>
            <div class="value">{{ certificate.list.chainNodeName }}</div>
          </div>

          <div class="issue">
            <div class="img-box">
              <img :src="certificate.list.sealFileUrl" alt="" />
            </div>
            <div class="name">{{ certificate.list.chainNodeName }}</div>
          </div>

          <div class="qrcode">
            <div class="img-box">
              <img :src="certificate.list.QRCodeUrl" alt="" />
            </div>
          </div>
        </div>
      <!-- </template>
      调解视频
      <template v-else-if="queryInfo.type==3">
      </template>
      呼叫录音
      <template v-else-if="queryInfo.type==6">
      </template> -->
    </div>   
  </div>
</template>

<script>
import VueQr from "vue-qr";//二维码插件

export default {
  data() {
    return {
      IP360: {},
      keyList: {},
      queryInfo: {},
      certificate: {
        list: {},
        type: '',
      },
      // 所属系统简称
      certApply: '',
      // 类似智签系统的证书数据项
      xconInfo: {},
      // 类似智签系统的合同列表
      xconFileList: [],
      // 二维码链接(拼接)
      codeValue: '',
      // 合同tab的当前项
      activeName: '',

      currentItem: {},
      htmls:"",
      //对接调解平台的证书title
      tjTitles:{
        6:{
          name:"呼叫录音存证证书"
        },
        3:{
          name:"调解视频存证证书"
        },
        2:{
          name:"电子送达存证证书"
        }
      }
    }
  },
  props: ['certificateType', 'certificateList'],
  created() {
    console.log("this.businessCode",'111111111111')
    this.queryInfo = this.$route.query;
    const {certificateNumber} = this.$route.query;
    if (certificateNumber.includes('XC-')) {
      this.certApply = 'Xcontract';
    } else if (certificateNumber.includes('GZFQ-BWX-')) {
      this.certApply = 'gzfq';
    }

    if (this.certApply == 'Xcontract' || this.certApply == 'gzfq') {
      this.getXconInfo()
    }
  },
  mounted() {
    // console.log(this.$route.query,"===================",this.certificate,"证书配置",this.queryInfo.partnerId)
    this.$store.commit('showLoading', true)
    this.IP360 = JSON.parse(window.localStorage.getItem('IP360'))
  },
  methods: {
    format(value, type) {
      // 1-年月日，2-年月日+时分秒
      var newValue = value, t1, t2, d2 = "";
      if (value && value.indexOf('~') != -1) {
        newValue = value.split("~");
        t1 = new Date(newValue[0]);
        t2 = new Date(newValue[1]);
        if (type == 1) {
          d2 = this.getYMH(t2, type);
        } else {
          d2 = this.getYMH(t1, type) + " ~ " + this.getYMH(t2, type)
        }
        return d2;
      } else {
        var d = new Date(newValue);
        if (type == 1) {
          d2 = this.getYMH(d, type);
        } else {
          d2 = this.getYMH(d, type);
        }
        return d2;
      }
    },
    getAdd(time) {
      if (time > 9) {
        return time
      } else {
        return "0" + time
      }
    },
    getYMH(dateTime, type) {
      if (type == 1) {
        return dateTime.getFullYear() + "年" + this.getAdd(dateTime.getMonth() + 1) + "月" + this.getAdd(dateTime.getDate()) + "日";
      } else {
        return dateTime.getFullYear() + "年" + this.getAdd(dateTime.getMonth() + 1) + "月" + this.getAdd(dateTime.getDate()) + "日" + this.getAdd(dateTime.getHours()) + "时" + this.getAdd(dateTime.getMinutes()) + "分" + this.getAdd(dateTime.getSeconds()) + "秒";
      }
    },
    initKey() {
      this.queryInfo = this.$route.query;
      if (!this.certificate.list) {

      }
      // console.log(this.certificate.list)
      // let listFlag=this.certificate.list?JSON.parse(this.certificate.list):''
      // console.log(listFlag)
      // if(listFlag instanceof Array){
      //   console.log("这是个数组")
      this.$store.commit('showLoading', true)
      this.$ajax.get('/webapi/validateQuery/getCertificateConfig', {
        params: {
          // 兼容公证处
          uid: this.$route.query.uid,
          type: this.certificate.list.productType || this.$route.query.type,
          partnerId: this.queryInfo.partnerId,
          certificateToken: 'truthso-certificate',
        }
      }).then((res) => {
        if (res.data.code == 200) {
          this.keyList = res.data.extraData
        }
        this.$store.commit('showLoading', false)
      })
    },
    getXconInfo() {
      this.$ajax.get('/webapi/validateQuery/getXconCertificate', {
        params: {
          certificateNumber: this.queryInfo.certificateNumber,
          fileId: this.queryInfo.contractFileId
        }
      }).then((res) => {
        if (res.data.code == 200) {
          const fileList = res.data.extraData.fileList;
          this.xconFileList = fileList;
          const sameIndex = fileList.findIndex(item => {
            return item.id === res.data.extraData.cert.fileId;
          })
          this.activeChange("", this.xconFileList[sameIndex]);
        }
        this.$store.commit('showLoading', false)
      })
    },
    getXconCert(id) {
      const sameIndex = this.xconFileList.findIndex(item => {
        return item.id  === id
      })
      this.$ajax.get('/webapi/validateQuery/getXconCertificateInfo', {
        params: {
          certificateNumber: this.queryInfo.certificateNumber,
          fileId: id
        }
      }).then((res) => {
        const xconCert = res.data.extraData.cert;
        if (this.certApply == 'gzfq') {
          this.$set(this.xconFileList[sameIndex], 'cert', xconCert);
          this.$set(this.xconFileList[sameIndex], 'codeValue', `https://fq.gz-notary.com/m/signComplete/?id=${xconCert.contract.id}&type=1`);
        } else if (this.certApply == 'Xcontract') {
          this.$set(this.xconFileList[sameIndex], 'cert', xconCert);
          this.$set(this.xconFileList[sameIndex], 'codeValue', `https://xcontract.cn/m/signComplete/?id=${xconCert.contract.id}&type=1`);
        }
      })
    },
    getSignUser(data) {
      let temp = "";
      if (data && data.length) {
        data.forEach(element => {
          temp += element.name + " ";
        });
      }
      return temp;
    },
    getPdfToImage(url, id) {
      let container = document.getElementById(id);
      container.style.display = "block";
      let _this = this;
      url =
          url ||
          "https://xcon-dev.oss-cn-beijing.aliyuncs.com/contract/7209/20200928/79917fbc30b24cfd93df29137c818b34.pdf";
      PDFJS.getDocument(url).then(function getPdfHelloWorld(pdf) {
        _this.totalPage = pdf.numPages;
        for (let i = 1; i <= _this.totalPage; i++) {
          $(container).append(
              `<div class="canvasBoxFlag" data-pageIndex=${i} id="canvasBoxFlag${i}${id}"><canvas data-pageIndex=${i} class="canvasContent" id="canvas${i}${id}"></canvas>
                </div>`
          );
          pdf.getPage(i).then(page => {
            _this.getPage(page, i, id);
          });
        }
      });
    },
    getPage(page, index, id) {
      var canvasContainerWidth = 460;
      var scale = 1; //缩放倍数，1表示原始大小
      var viewport = page.getViewport(scale);
      viewport = page.getViewport(canvasContainerWidth / viewport.width);
      var canvas = document.getElementById("canvas" + index + id);
      var canvasFather = canvas.parentNode;
      var context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      canvasFather.style.width = viewport.width + "px";
      canvasFather.style.height = viewport.height + "px";
      var renderContext = {
        canvasContext: context,
        viewport: viewport
      };
      page.render(renderContext).promise.then(() => {
        this.loadedPageCount++;
      });
    },
    activeChange(node, item) {
      this.currentItem = (node && node.$attrs.item) || item;
      this.activeName = this.currentItem.id;
      if (!this.currentItem.cert) {
        this.getXconCert(this.currentItem.id)
      }
      this.$nextTick(() => {
        this.getPdfToImage(this.currentItem.filePath, this.currentItem.id);
      });
    },
  },
  watch: {
    certificateList(curVal, oldVal) {
      if (curVal) {
        this.certificate.list = curVal
        this.certificate.list.summary ? this.certificate.list.summary = JSON.parse(curVal.summary) : '';
        if(this.queryInfo.partnerId == 1){
           //IP360需要单独设置样式
          this.htmls=curVal.htmlUrl;
          setTimeout(()=>{
            $('.certificate-url').eq(0).css('margin-top','131px');
          },200)
        }else if(this.queryInfo.partnerId == 21){
          //上海东方存证展示。
          this.htmls=curVal.htmlUrl;
          setTimeout(()=>{
            $('.certificate-url').eq(0).css('margin-top','131px');
          },200)
        }
        this.initKey()
      }
      // console.log(this.certificate,'certificatelist')
    },
    keyList(curVal, oldVal) {
      if (curVal) {
        this.keyList = curVal
      }
    }
  },
  components: {
    VueQr
  },
}
</script>

<style scoped lang="scss">
/* 目前证书 */
.common-certificate {
  float: left;
}
.certificate-see{
    width: 470px;
    height: 690px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 32px;
  }
  .certificate-see::-webkit-scrollbar{
    width: 3px;
    background: #eee;
  }
  .certificate-see::-webkit-scrollbar-track{
    opacity: 0;
  }
  .certificate-see::-webkit-scrollbar-thumb{
    width: 3px;
    background: #ccc;
  }

/* 钱塘证书 */
.see_qt {
  width: 470px;
  height: 650px;
  background: url(../../assets/images/common/qt/certificate.png) no-repeat center;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_qt > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 34px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_qt .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 15px;
}

.see_qt .introduce {
  width: 392px;
  line-height: 20px;
  margin: 3px auto 0 auto;
  /* 文字缩进 */
  text-indent: 24px;
}

.see_qt > .abstract {
  width: 390px;
  /*margin: 0 auto;*/
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_qt > .abstract > span,
.see_qt > .detail-line > span {
  float: left;
}

.see_qt > .abstract > span:nth-child(1),
.see_qt > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_qt > .abstract > span:nth-child(2) {
  width: 300px;
  word-wrap: break-word;
  word-break: normal;
}

.see_qt .detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.see_qt .detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.see_qt .detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_qt .detail-line {
  width: 380px;
  height: 17px;
  margin: 0 auto;
  /*position: absolute;*/
  /*left: 50%;*/
  /*top: 0;*/
  /*transform: translate(-50%, 0);*/
}

.see_qt > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 38px;
  transform: translate(-50%, 0);
}

.see_qt > .issue > p {
  font-size: 12px;
  line-height: 20px;
  margin-top: 5px;
}

.see_qt .QRCode {
  width: 59px;
  height: 59px;
  position: absolute;
  bottom: 40px;
  left: 112px;
  /* background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center; */
  padding: 2px;
}

.see_qt .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 0 auto;
}

.null-data {
  visibility: hidden;
  opacity: 0;
}

/* 老版本证书 */

/* 老证书 */

.new_see_qt {
  width: 440px;
  height: 650px;
  background: url(../../assets/images/common/qt/_newcertificate.png) no-repeat center;
  background-size: cover;
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
}

.new_see_qt > .title {
  font-size: 16px;
  line-height: 16px;
  color: #333;
  text-align: center;
  margin-top: 85px;
  font-weight: bold;
  width: 100% !important;
  /*margin-bottom: 5px;*/
  padding-bottom: 5px;
}

.new_see_qt > .issue {
  margin: 4px 0 0 55px;
}

.new_see_qt > .abstract {
  width: 365px;
  margin: 0 auto;
}

.new_see_qt > .abstract > span:nth-child(1) {
  width: 90px;
  float: left;
  text-align: right;
}

.new_see_qt > .abstract > span:nth-child(2) {
  float: left;
  width: 270px;
  word-wrap: break-word;
  word-break: normal;
}

.new_see_qt > .detail-line {
  width: 365px;
  margin: 0 auto;
}

.new_see_qt > .detail-line > span:nth-child(1) {
  width: 90px;
  float: left;
  text-align: right;
}

.new_see_qt > .QRCode {
  bottom: 50px;
  left: 48px;
}

/* 钱塘证书 */

/* 广州 */
.see_new_gz {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/gz/certificate.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_gz > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_gz > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_gz > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_gz > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_gz > .abstract > span,
.see_new_gz > .detail-line > span {
  float: left;
}

.see_new_gz > .abstract > span:nth-child(1),
.see_new_gz > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_gz > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_gz > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_gz > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 166px;
  transform: translate(-50%, 0);
}

.see_new_gz > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_gz > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_gz > .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 3px auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}

/* 二代证书 */
.see_gz {
  width: 470px;
  height: 651px;
  background: url(../../assets/images/common/gz/certificatev2.png) no-repeat center;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_gz > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 34px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 9px;
}

.introduce {
  width: 400px;
  line-height: 22px;
  margin: 10px auto 0 auto;
  /* 文字缩进 */
  text-indent: 24px;
}

.see_gz > .abstract {
  width: 380px;
  /*margin: 0 auto;*/
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_gz > .abstract > span,
.see_gz > .detail-line > span {
  float: left;
}

.see_gz > .abstract > span:nth-child(1),
.see_gz > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_gz > .abstract > span:nth-child(2) {
  width: 290px;
  word-wrap: break-word;
  word-break: normal;
}

.see_gz .detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.see_gz .detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.see_gz .detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_gz .detail-line {
  width: 380px;
  height: 17px;
  margin: 0 auto;
  /*position: absolute;*/
  /*left: 50%;*/
  /*top: 0;*/
  /*transform: translate(-50%, 0);*/
}

.see_gz > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 75px;
  transform: translate(-50%, 0);
}

.see_gz > .issue > p {
  font-size: 12px;
  line-height: 12px;
  margin-top: 5px;
}

.see_gz, .new_see_gz .QRCode {
  width: 59px;
  height: 59px;
  position: absolute;
  bottom: 21px;
  left: 48px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_gz, .new_see_gz .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 0 auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}

/* 老版本证书 */

/* 老证书 */

.new_see_gz {
  width: 440px;
  height: 650px;
  background: url(../../assets/images/common/gz/_newcertificate.png) no-repeat center;
  background-size: cover;
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
}

.new_see_gz > .title {
  font-size: 16px;
  line-height: 16px;
  color: #333;
  text-align: center;
  margin-top: 85px;
  font-weight: bold;
  width: 100% !important;
  /*margin-bottom: 5px;*/
  padding-bottom: 5px;
}

.new_see_gz > .issue {
  margin: 4px 0 0 55px;
}

.new_see_gz > .abstract {
  width: 365px;
  margin: 0 auto;
}

.new_see_gz > .abstract > span:nth-child(1) {
  width: 90px;
  float: left;
  text-align: right;
}

.new_see_gz > .abstract > span:nth-child(2) {
  float: left;
  width: 270px;
  word-wrap: break-word;
  word-break: normal;
}

.new_see_gz > .detail-line {
  width: 365px;
  margin: 0 auto;
}

.new_see_gz > .detail-line > span:nth-child(1) {
  width: 90px;
  float: left;
  text-align: right;
}

.new_see_gz > .QRCode {
  bottom: 50px;
  left: 48px;
}

/* 广州 */

/* 内蒙 */
.see_nm {
  width: 470px;
  height: 589px;
  background: url(../../assets/images/common/nm/certificate.png) no-repeat center;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_nm > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 34px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_nm, .new_see_nm .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 9px;
}

.see_nm, .new_see_nm .introduce {
  width: 400px;
  line-height: 22px;
  margin: 10px auto 0 auto;
  /* 文字缩进 */
  text-indent: 24px;
}

.see_nm > .abstract {
  width: 380px;
  /*margin: 0 auto;*/
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_nm > .abstract > span,
.see_nm > .detail-line > span {
  float: left;
}

.see_nm > .abstract > span:nth-child(1),
.see_nm > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_nm > .abstract > span:nth-child(2) {
  width: 290px;
  word-wrap: break-word;
  word-break: normal;
}

.see_nm, .new_see_nm .detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.see_nm, .new_see_nm .detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.see_nm, .new_see_nm .detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_nm, .new_see_nm .detail-line {
  width: 380px;
  height: 17px;
  margin: 0 auto;
  /*position: absolute;*/
  /*left: 50%;*/
  /*top: 0;*/
  /*transform: translate(-50%, 0);*/
}

.see_nm > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 82px;
  transform: translate(-50%, 0);
}

.see_nm > .issue > p {
  font-size: 12px;
  line-height: 10px;
  margin-top: 5px;
}

.see_nm, .new_see_nm .QRCode {
  width: 59px;
  height: 59px;
  position: absolute;
  bottom: 21px;
  left: 48px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_nm, .new_see_nm .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 0 auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}

/* 老版本证书 */

/* 老证书 */

.new_see_nm {
  width: 440px;
  height: 650px;
  background: url(../../assets/images/common/nm/_newcertificate.png) no-repeat center;
  background-size: cover;
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
}

.new_see_nm > .title {
  font-size: 16px;
  line-height: 16px;
  color: #333;
  text-align: center;
  margin-top: 85px;
  font-weight: bold;
  width: 100% !important;
  /*margin-bottom: 5px;*/
  padding-bottom: 5px;
}

.new_see_nm > .issue {
  margin: 4px 0 0 55px;
}

.new_see_nm > .abstract {
  width: 365px;
  margin: 0 auto;
}

.new_see_nm > .abstract > span:nth-child(1) {
  width: 90px;
  float: left;
  text-align: right;
}

.new_see_nm > .abstract > span:nth-child(2) {
  float: left;
  width: 270px;
  word-wrap: break-word;
  word-break: normal;
}

.new_see_nm > .detail-line {
  width: 365px;
  margin: 0 auto;
}

.new_see_nm > .detail-line > span:nth-child(1) {
  width: 90px;
  float: left;
  text-align: right;
}

.new_see_nm > .QRCode {
  bottom: 50px;
  left: 48px;
}

/* 内蒙 */

/* 方正 */
.see_new_four_fz {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/fz/certificatenNowFour.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_four_fz > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_four_fz > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_four_fz > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_four_fz > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_four_fz > .abstract > span,
.see_new_four_fz > .detail-line > span {
  float: left;
}

.see_new_four_fz > .abstract > span:nth-child(1),
.see_new_four_fz > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_four_fz > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.see_new_four_fz .detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.see_new_four_fz .detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.see_new_four_fz .detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_four_fz > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_four_fz > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 166px;
  transform: translate(-50%, 0);
}

.see_new_four_fz > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_four_fz > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_four_fz > .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 3px auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}

/* v3 */
.see_new_fz {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/fz/certificate_three.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_fz > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_fz > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_fz > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_fz > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_fz > .abstract > span,
.see_new_fz > .detail-line > span {
  float: left;
}

.see_new_fz > .abstract > span:nth-child(1),
.see_new_fz > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_fz > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.see_new_fz .detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.see_new_fz .detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.see_new_fz .detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_fz > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_fz > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 166px;
  transform: translate(-50%, 0);
}

.see_new_fz > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_fz > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_fz > .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 3px auto;
}


.see_new_fz .null-data {
  visibility: hidden;
  opacity: 0;
}

/* 二代证书 */
.see_fz {
  width: 470px;
  height: 651px;
  background: url(../../assets/images/common/fz/certificatev2.png) no-repeat center;
  background-size: 100% 100%;
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_fz > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 23px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 9px;
}

.see_fz > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 4px;
}

.introduce {
  width: 400px;
  line-height: 16px;
  margin: 2px auto 0 auto;
  /* 文字缩进 */
  text-indent: 24px;
}

.see_fz > .abstract {
  width: 380px;
  /*margin: 0 auto;*/
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_fz > .abstract > span,
.see_fz > .detail-line > span {
  float: left;
}

.see_fz > .abstract > span:nth-child(1),
.see_fz > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_fz > .abstract > span:nth-child(2) {
  width: 290px;
  word-wrap: break-word;
  word-break: normal;
}

.detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.detail-line {
  width: 380px;
  height: 17px;
  margin: 0 auto;
  /*position: absolute;*/
  /*left: 50%;*/
  /*top: 0;*/
  /*transform: translate(-50%, 0);*/
}

.see_fz > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 158px;
  transform: translate(-50%, 0);
}

.see_fz > .issue > p {
  font-size: 12px;
  line-height: 7px;
  margin-top: 10px;
}

.see_fz > .QRCode {
  width: 59px;
  height: 59px;
  position: absolute;
  bottom: 159px;
  left: 48px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_fz > .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 0 auto;
}


.see_fz, .new_see_fz .QRCode {
  width: 59px;
  height: 59px;
  position: absolute;
  bottom: 21px;
  left: 48px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_fz, .new_see_fz .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 0 auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}

/* 老版本证书 */

/* 老证书 */

.new_see_fz {
  width: 440px;
  height: 650px;
  background: url(../../assets/images/common/fz/_newcertificate.png) no-repeat center;
  background-size: cover;
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
}

.new_see_fz > .title {
  font-size: 16px;
  line-height: 16px;
  color: #333;
  text-align: center;
  margin-top: 85px;
  font-weight: bold;
  width: 100% !important;
  /*margin-bottom: 5px;*/
  padding-bottom: 5px;
}

.new_see_fz > .issue {
  margin: 4px 0 0 55px;
}

.new_see_fz > .abstract {
  width: 365px;
  margin: 0 auto;
}

.new_see_fz > .abstract > span:nth-child(1) {
  width: 90px;
  float: left;
  text-align: right;
}

.new_see_fz > .abstract > span:nth-child(2) {
  float: left;
  width: 270px;
  word-wrap: break-word;
  word-break: normal;
}

.new_see_fz > .detail-line {
  width: 365px;
  margin: 0 auto;
}

.new_see_fz > .detail-line > span:nth-child(1) {
  width: 90px;
  float: left;
  text-align: right;
}

.new_see_fz > .QRCode {
  bottom: 50px;
  left: 48px;
}

/* 方正 */


/* 温州 */
.see_new_wz {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/wz/certificate.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_wz > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_wz > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_wz > .introduce {
  width: 420px;
  line-height: 18px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_wz > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_wz > .abstract > span,
.see_new_wz > .detail-line > span {
  float: left;
}

.see_new_wz > .abstract > span:nth-child(1),
.see_new_wz > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_wz > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.see_new_wz .detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.see_new_wz .detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.see_new_wz .detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_wz > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_wz > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 166px;
  transform: translate(-50%, 0);
}

.see_new_wz > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_wz > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_wz > .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 3px auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}

/* 二代证书 */
.see_wz {
  width: 470px;
  height: 651px;
  background: url(../../assets/images/common/wz/certificatev2.png) no-repeat center;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_wz > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 34px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_wz .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 9px;
}

.see_wz .introduce {
  width: 400px;
  line-height: 22px;
  margin: 10px auto 0 auto;
  /* 文字缩进 */
  text-indent: 24px;
}

.see_wz > .abstract {
  width: 380px;
  /*margin: 0 auto;*/
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_wz > .abstract > span,
.see_wz > .detail-line > span {
  float: left;
}

.see_wz > .abstract > span:nth-child(1),
.see_wz > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_wz > .abstract > span:nth-child(2) {
  width: 290px;
  word-wrap: break-word;
  word-break: normal;
}

.see_wz .detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.see_wz, .new_see_wz .detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.see_wz, .new_see_wz .detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_wz, .new_see_wz .detail-line {
  width: 380px;
  height: 17px;
  margin: 0 auto;
  /*position: absolute;*/
  /*left: 50%;*/
  /*top: 0;*/
  /*transform: translate(-50%, 0);*/
}

.see_wz > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 75px;
  transform: translate(-50%, 0);
}

.see_wz > .issue > p {
  font-size: 12px;
  line-height: 12px;
  margin-top: 5px;
}

.new_see_wz, .see_wz .QRCode {
  width: 59px;
  height: 59px;
  position: absolute;
  bottom: 21px;
  left: 48px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.new_see_wz, .see_wz .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 0 auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}

/* 老版本证书 */

/* 老证书 */

.new_see_wz {
  width: 440px;
  height: 650px;
  background: url(../../assets/images/common/wz/_newcertificate.png) no-repeat center;
  background-size: cover;
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
}

.new_see_wz > .title {
  font-size: 16px;
  line-height: 16px;
  color: #333;
  text-align: center;
  margin-top: 85px;
  font-weight: bold;
  width: 100% !important;
  /*margin-bottom: 5px;*/
  padding-bottom: 5px;
}

.new_see_wz > .issue {
  margin: 4px 0 0 55px;
}

.new_see_wz > .abstract {
  width: 365px;
  margin: 0 auto;
}

.new_see_wz > .abstract > span:nth-child(1) {
  width: 90px;
  float: left;
  text-align: right;
}

.new_see_wz > .abstract > span:nth-child(2) {
  float: left;
  width: 270px;
  word-wrap: break-word;
  word-break: normal;
}

.new_see_wz > .detail-line {
  width: 365px;
  margin: 0 auto;
}

.new_see_wz > .detail-line > span:nth-child(1) {
  width: 90px;
  float: left;
  text-align: right;
}

.new_see_wz > .QRCode {
  bottom: 50px;
  left: 48px;
}

/* 温州 */


/* 渤海的证书 */
/* 目前证书 */
.see_new_bh {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/bh/certificate.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_bh > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_bh > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_bh > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_bh > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_bh > .abstract > span,
.see_new_bh > .detail-line > span {
  float: left;
}

.see_new_bh > .abstract > span:nth-child(1),
.see_new_bh > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_bh > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_bh > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_bh > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 166px;
  transform: translate(-50%, 0);
}

.see_new_bh > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_bh > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_bh > .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 3px auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}

/* 二代证书 */
.see_bh {
  width: 470px;
  height: 651px;
  background: url(../../assets/images/common/bh/certificatev2.png) no-repeat center;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_bh > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 34px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 9px;
}

.introduce {
  width: 400px;
  line-height: 22px;
  margin: 10px auto 0 auto;
  /* 文字缩进 */
  text-indent: 24px;
}

.see_bh > .abstract {
  width: 380px;
  /*margin: 0 auto;*/
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_bh > .abstract > span,
.see_bh > .detail-line > span {
  float: left;
}

.see_bh > .abstract > span:nth-child(1),
.see_bh > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_bh > .abstract > span:nth-child(2) {
  width: 290px;
  word-wrap: break-word;
  word-break: normal;
}

.detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.detail-line {
  width: 380px;
  height: 17px;
  margin: 0 auto;
  /*position: absolute;*/
  /*left: 50%;*/
  /*top: 0;*/
  /*transform: translate(-50%, 0);*/
}

.see_bh > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 75px;
  transform: translate(-50%, 0);
}

.see_bh > .issue > p {
  font-size: 12px;
  line-height: 12px;
  margin-top: 5px;
}

.see_bh .QRCode {
  width: 59px;
  height: 59px;
  position: absolute;
  bottom: 21px;
  left: 48px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_bh .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 0 auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}

/* 老版本证书 */

/* 老证书 */

.new_see_bh {
  width: 440px;
  height: 650px;
  background: url(../../assets/images/common/bh/_newcertificate.png) no-repeat center;
  background-size: cover;
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
}

.new_see_bh > .title {
  font-size: 16px;
  line-height: 16px;
  color: #333;
  text-align: center;
  margin-top: 85px;
  font-weight: bold;
  width: 100% !important;
  /*margin-bottom: 5px;*/
  padding-bottom: 5px;
}

.new_see_bh > .issue {
  margin: 4px 0 0 55px;
}

.new_see_bh > .abstract {
  width: 365px;
  margin: 0 auto;
}

.new_see_bh > .abstract > span:nth-child(1) {
  width: 90px;
  float: left;
  text-align: right;
}

.new_see_bh > .abstract > span:nth-child(2) {
  float: left;
  width: 270px;
  word-wrap: break-word;
  word-break: normal;
}

.new_see_bh > .detail-line {
  width: 365px;
  margin: 0 auto;
}

.new_see_bh > .detail-line > span:nth-child(1) {
  width: 90px;
  float: left;
  text-align: right;
}

.new_see_bh > .QRCode {
  bottom: 50px;
  left: 48px;
}

/* 渤海的证书 */


/*佛山证书 */
/* 目前证书 */
.common-certificate {
  float: left;
}

.see_new_four_fs {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/fs/certificatenFourNow.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_four_fs > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_four_fs > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_four_fs > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_four_fs > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_four_fs > .abstract > span,
.see_new_four_fs > .detail-line > span {
  float: left;
}

.see_new_four_fs > .abstract > span:nth-child(1),
.see_new_four_fs > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_four_fs > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_four_fs > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_four_fs > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 166px;
  transform: translate(-50%, 0);
}

.see_new_four_fs > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_four_fs > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_four_fs > .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 3px auto;
}


.see_new_four_fs_right {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/fs/certificatenFourNow_rights.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_four_fs_right > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_four_fs_right > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_four_fs_right > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_four_fs_right > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_four_fs_right > .abstract > span,
.see_new_four_fs_right > .detail-line > span {
  float: left;
}

.see_new_four_fs_right > .abstract > span:nth-child(1),
.see_new_four_fs_right > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_four_fs_right > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_four_fs_right > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_four_fs_right > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 166px;
  transform: translate(-50%, 0);
}

.see_new_four_fs_right > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_four_fs_right > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_four_fs_right > .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 3px auto;
}

.null-data {
  visibility: hidden;
  opacity: 0;
}

.QRCode {
  width: 59px;
  height: 59px;
  position: absolute;
  bottom: 21px;
  left: 48px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.QRCode > img {
  width: 55px;
  height: 55px;
  margin: 0 auto;
}


/*佛山证书 */


/*安顿证书 */
.see_new_ad {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/ad/certificatenew.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_ad > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_ad > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_ad > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_ad > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_ad > .abstract > span,
.see_new_ad > .detail-line > span {
  float: left;
}

.see_new_ad > .abstract > span:nth-child(1),
.see_new_ad > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_ad > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_ad > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_ad > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 166px;
  transform: translate(-50%, 0);
}

.see_new_ad > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_ad > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_ad > .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 3px auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}


/*安顿证书 */


/*方圆证书 */
.see_new_four_fy {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/fy/certificatenew.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_four_fy > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_four_fy > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_four_fy > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_four_fy > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_four_fy > .abstract > span,
.see_new_four_fy > .detail-line > span {
  float: left;
}

.see_new_four_fy > .abstract > span:nth-child(1),
.see_new_four_fy > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_four_fy > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.see_new_four_fy .detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.see_new_four_fy .detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.see_new_four_fy .detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_four_fy > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_four_fy > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 166px;
  transform: translate(-50%, 0);
}

.see_new_four_fy > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_four_fy > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_four_fy > .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 3px auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}

/*方圆证书 */


/* 精诚证书 */

/* 目前证书 */
.jc-common-certificate {
  float: left;
}

.jc-see_new_four {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/jc/certificatenFourNow.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.jc-see_new_four > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.jc-see_new_four > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.jc-see_new_four > .jc-introduce {
  width: 388px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  /* text-indent: 24px; */
  word-break: break-all;
  margin-top: 6px;
}

.jc-see_new_fourr > .jc-introduce > p {
  text-indent: 24px;
}

.jc-see_new_four > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.jc-see_new_four > .abstract > span,
.jc-see_new_four > .detail-line > span {
  float: left;
}

.jc-see_new_four > .abstract > span:nth-child(1),
.jc-see_new_four > .detail-line > span:nth-child(1) {
  width: 90px;
  text-align: right;
}

.jc-see_new_four > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}

.jc-see_new_four > .detail-lines > span:nth-child(2) {
  width: 316px;
  overflow: inherit;
  text-overflow: initial;
  white-space: normal;
  word-break: break-all;
  float: left;
}

.detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.jc-see_new_four > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.jc-see_new_four > .detail-lines {
  margin-top: 10px !important;
}

.jc-see_new_four > .jc-issue {
  text-align: center;
  position: absolute;
  left: 57%;
  bottom: 159px;
  transform: translate(-50%, 0);
}

.jc-see_new_four > .jc-issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
  color: #363636
}

.jc-see_new_four > .jc-QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 144px;
  left: 37px;
  /* background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center; */
  padding: 2px;
}

.jc-see_new_four > .jc-QRCode > img {
  width: 55px;
  height: 55px;
  margin: 3px auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}

/* 精诚证书 */


/*国立证书 */
.see_new_four_cdgl {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/cdgl/certificatenew_v4.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_four_cdgl > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_four_cdgl > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_four_cdgl > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_four_cdgl > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_four_cdgl > .abstract > span,
.see_new_four_cdgl > .detail-line > span {
  float: left;
}

.see_new_four_cdgl > .abstract > span:nth-child(1),
.see_new_four_cdgl > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_four_cdgl > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.see_new_four_cdgl .detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.see_new_four_cdgl .detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.see_new_four_cdgl .detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_four_cdgl > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_four_cdgl > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 166px;
  transform: translate(-50%, 0);
}

.see_new_four_cdgl > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_four_cdgl > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_four_cdgl > .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 3px auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}


/*广东广州证书 */
.see_new_four_gzfq {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/gzfq/certificatenew_v4.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_four_gzfq > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_four_gzfq > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_four_gzfq > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_four_gzfq > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_four_gzfq > .abstract > span,
.see_new_four_gzfq > .detail-line > span {
  float: left;
}

.see_new_four_gzfq > .abstract > span:nth-child(1),
.see_new_four_gzfq > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_four_gzfq > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.see_new_four_gzfq .detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.see_new_four_gzfq .detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.see_new_four_gzfq .detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_four_gzfq > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_four_gzfq > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 166px;
  transform: translate(-50%, 0);
}

.see_new_four_gzfq > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_four_gzfq > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_four_gzfq > .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 4px;
}

/*方圆证书 */


.see_new_four_dc {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/dc/certificatenew_v4.png) no-repeat center;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_four_dc > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_four_dc > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_four_dc > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_four_dc > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_four_dc > .abstract > span,
.see_new_four_dc > .detail-line > span {
  float: left;
}

.see_new_four_dc > .abstract > span:nth-child(1),
.see_new_four_dc > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_four_dc > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_four_dc > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_four_dc > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 164px;
  transform: translate(-50%, 0);
}

.see_new_four_dc > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_four_dc > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_four_dc > .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 3px auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}

/* 辰信证书 */
.common-certificate {
  float: left;
}

.see_new_four_cx {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/cx/certificatenew_v4.png) no-repeat center;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_four_cx > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_four_cx > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_four_cx > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_four_cx > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_four_cx > .abstract > span,
.see_new_four_cx > .detail-line > span {
  float: left;
}

.see_new_four_cx > .abstract > span:nth-child(1),
.see_new_four_cx > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_four_cx > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_four_cx > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_four_cx > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 164px;
  transform: translate(-50%, 0);
}

.see_new_four_cx > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_four_cx > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_four_cx > .QRCode > img {
  width: 55px;
  height: 55px;
  margin: 3px auto;
}


.null-data {
  visibility: hidden;
  opacity: 0;
}

/* 辰信证书 */

/* 电子签约证书 */
.xcon-cert {
  margin-top: 32px;
  padding-bottom: 70px;
  width: 990px;
  height: auto;
  display: flex;
  justify-content: space-between;

  .contentContainer {
    background: url(../../assets/images/common/cert-xcon/certificate-xcon-bg.png) no-repeat;
    background-size: 100% 100%;
    width: 470px;
    height: 890px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 10px 5% 20px 5%;
  }

  .proFlag {
    width: 140px;
    height: 60px;
    margin: 0 auto;
    margin-bottom: 20px;
    background: url(../../assets/images/common/cert-xcon/logo02_img.png);
    background-size: 100%;
  }

  .proTitle {
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #323232;
    text-align: center;
    line-height: 20px;
    margin-bottom: 14px;
    font-weight: bold;
  }

  .proId {
    font-size: 14px;
    color: #464646;
    text-align: center;
    line-height: 14px;
    margin-bottom: 20px;
  }

  .proDscp {
    font-size: 14px;
    color: #464646;
    text-align: justify;
    line-height: 16px;
    text-indent: 2em;
    margin-bottom: 20px;
  }

  .proIdList {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    box-sizing: border-box;
    padding: 30px 30px;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #646464;
    line-height: 12px;
    background: rgba(0, 0, 0, 0.04);
  }

  .proIdList .item {
    display: flex;
    justify-content: space-around;
  }

  .proIdList .item .label {
    width: 94px;
    text-align: left;
    font-size: 12px;
    word-break: break-all;
    line-height: 28px;
  }

  .proIdList .item .content {
    width: 220px;
    text-align: left;
    font-size: 12px;
    line-height: 14px;
    flex: 1;
    word-break: break-all;
  }

  .formItem {
    background: none;
    padding: 0 40px;
    height: auto;
    position: relative;
    margin-bottom: 37px;
  }

  .formItem .item {
    margin-bottom: 10px;
  }

  .formItem .item .label {
    line-height: 12px;
  }

  .formItem .item .content {
    font-size: 12px;
    line-height: 12px;
    margin-top: 0px;
  }

  .formItem .seaImage {
    position: absolute;
    background: url(../../assets/images/common/cert-xcon/seal02_img.png);
    width: 127px;
    height: 106px;
    bottom: 20px;
    left: 182px;
  }

  .bottomDetail {
    width: 100%;
    height: 126px;
    display: flex;
    justify-content: space-between;

  }

  .bottomDetail .sealPower {
    width: calc(100% - 150px);
    height: 126px;
    background: url(../../assets/images/common/cert-xcon/chapter02_img.png) no-repeat;
    background-size: contain;
    background-position: center center;
    flex-shrink: 0;
    margin-top: -10px;
  }

  .bottomDetail .qrcodeBox {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-left: 24px;

  }

  .bottomDetail .qrcodeBox img {
    width: 80px;
    height: 80px;
    margin-bottom: 10px;
  }

  .bottomDetail .qrcodeDscp {
    font-size: 14px;
    color: #646464;
    text-align: center;
    line-height: 14px;
  }

  .xcon-file-block {
    //height: 890px;
    overflow-y: auto;
    background: #fff;
    width: 100%;
    padding-bottom: 20px;

    .active-default {
      width: 8px;
      height: 8px;
      background: #e2344a;
      display: inline-block;
      border-radius: 50%;
    }

    .xcon-cert-box {
      display: flex;
      justify-content: space-around;

      .xcon-cert-item {
        height: 890px;
        overflow-y: auto;
        width: 477px;
      }
    }
  }

  /deep/ .el-tabs__item.is-active {
    color: #e2344a;
  }
}


/* 赋强证书 start */

.fq-sass-cert {
  margin-top: 32px;
  padding-bottom: 70px;
  width: 990px;
  height: auto;
  display: flex;
  justify-content: space-between;

  .contentContainer {
    width: 440px;
    //height: 890px;
    height: 690px;
    box-sizing: border-box;
    background: url(./../../assets/images/common/cert-fq/Group_bg.png);
    background-size: 100% 100%;
    padding: 10px 30px 20px 30px;

    .proTitle {
      font-family: PingFangSC-Medium;
      font-size: 13px;
      margin: 14px auto;
      background: url(./../../assets/images/common/cert-fq/Group_title.png) no-repeat;
      background-size: cover;
      width: 200px;
      height: 36px;
      line-height: 26px;
      color: #fff;
      text-align: center;
    }

    .proId {
      font-size: 12px;
      color: #464646;
      text-align: center;
      line-height: 12px;
      margin-bottom: 6px;
    }

    .proDscp {
      font-size: 11px;
      color: #787878;
      text-align: justify;
      line-height: 16px;
      text-indent: 2em;
      margin-bottom: 12px;
    }

    .proIdList {
      width: 100%;
      height: auto;
      box-sizing: border-box;
      padding: 10px;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #646464;
      line-height: 12px;

      .item {
        display: flex;
        justify-content: space-around;

        .label {
          width: 94px;
          text-align: right;
          font-size: 11px;
          word-break: break-all;
          line-height: 11px;
          color: #505050;
        }

        .content {
          word-wrap: break-word;
          width: 237px;
          text-align: left;
          font-size: 12px;
          line-height: 14px;
          color: #646464;
        }
      }
    }

    .formItem {
      background: none;
      height: auto;
      position: relative;

      .item {
        margin-bottom: 6px;

        &:last-child {
          margin-bottom: 0;
        }

        .label {
          line-height: 11px;
        }

        .content {
          font-size: 12px;
          line-height: 12px;
          margin-top: 0px;
        }
      }
    }

    .proIdNumber {
      background: #FAFAFA;

      .item {
        margin-bottom: 14px;
        display: flex;
        flex-direction: row;
        align-items: center;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .bottomDetail {
      width: 100%;
      height: 63px;
      display: flex;

      .sealPower,
      .sealFq {
        position: relative;
        text-align: center;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;

        .seal-item {
          height: 56px;
          width: 56px;
          position: absolute;
          top: 0;
          left: 50%;
          margin-left: -28px;
        }

        .seal-title-h1 {
          color: #505050;
          font-size: 10px;
          font-weight: bolder;
          margin-bottom: 8px;
          margin-top: 20px;
        }

        .seal-title-h2 {
          color: #A0A0A0;
          font-size: 10px;
        }
      }

      .sealPower {
        margin-left: 55px;

        .seal-item {
          background: url(./../../assets/images/common/cert-fq/chapter02_img.png);
          background-size: cover;
        }
      }

      .sealFq {
        margin-left: 10px;

        .seal-item {
          background: url(./../../assets/images/common/cert-fq/seal_fq.png);
          background-size: cover;
        }
      }

      .qrcodeBox {
        display: flex;
        flex-direction: row;
        width: 108px;
        align-items: center;
        flex-shrink: 0;

        img {
          width: 60px;
          height: 60px;
        }
      }

      .qrcodeDscp {
        font-size: 8px;
        color: #505050;
        text-align: left;
        line-height: 14px;
      }
    }
  }

  .xcon-file-block {
    padding-bottom: 20px;
    background: #fff;
    width: 100%;

    .active-default {
      width: 8px;
      height: 8px;
      background: #e2344a;
      display: inline-block;
      border-radius: 50%;
    }

    .xcon-cert-box {
      display: flex;
      justify-content: space-around;

      .xcon-cert-item {
        height: 690px;
        overflow-y: auto;
        width: 477px;
      }
    }
  }

  /deep/ .el-tabs__item.is-active {
    color: #e2344a;
  }
}

/*  赋强证书 end */

/*东方证书 */
.see_new_four_df {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/df/certificatenew.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_four_df > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_four_df > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_four_df > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_four_df > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_four_df > .abstract > span,
.see_new_four_df > .detail-line > span {
  float: left;
}

.see_new_four_df > .abstract > span:nth-child(1),
.see_new_four_df > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_four_df > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.see_new_four_df .detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.see_new_four_df .detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.see_new_four_df .detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_four_df > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_four_df > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 166px;
  transform: translate(-50%, 0);
}

.see_new_four_df > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_four_df > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_four_df > .QRCode > img {
  width: 65px;
  height: 65px;
  margin: 2px auto;
}

// 对接调节平台
.certificate_tj {
  width: 555px;
  height: 819px;
  background: url("../../assets/images/common/certificatenew_TJ_v4.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  text-align: left;
  padding-top: 1px;
  margin: 28px 0px 35px 0px;
  .certificate_title {
    width: 100% !important;
    height: 42px;
    font-size: 14px;
    line-height: 31px;
    color: #fff;
    text-align: center;
    margin-top: 30px;
    font-weight: normal;
    background: url("../../assets/images/common/certificate-title.png") no-repeat
      center;
    margin-bottom: 10px;
  }
  .certificate-number {
    width: 100%;
    text-align: center;
    margin: 8px 0;
    font-size:14px;
  }
  .introduce {
    width: 500px;
    line-height: 22px;
    margin: 0px auto;
    text-indent: 24px;
    font-size:14px;
  }

  .hash-box {
    width: 100%;
    height: 126px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size:14px;
  }

  .message {
    width: 500px;
    display: flex;
    align-items: center;
    font-size:14px;
    margin: 8px auto;
    &.message-no-margin {
      margin: 0 auto 8px;
    }
    .text {
      width: 120px;
      flex-shrink: 0;
      text-align: right;
      margin-right: 8px;
    }
    .value {
      flex: 1;
      word-wrap: break-word;
      word-break: break-all;
      white-space: pre-wrap;
    }
  }

  .issue {
    width: 210px;
    text-align: center;
    position: absolute;
    left: 330px;
    bottom: 123px;
    font-size:14px;
    .img-box {
      width: 80px;
      height: 80px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .name {
      margin: 6px 0 0 0;
      font-size: 13px;
    }
  }

  .qrcode {
    width: 80px;
    height: 80px;
    position: absolute;
    left: 46px;
    bottom: 146px;
    .img-box {
      width: 80px;
      height: 80px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}


.see_new_four_hnswzx {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/hnsjg/certificatenew_v4.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_four_hnswzx > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_four_hnswzx > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_four_hnswzx > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_four_hnswzx > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_four_hnswzx > .abstract > span,
.see_new_four_hnswzx > .detail-line > span {
  float: left;
}

.see_new_four_hnswzx > .abstract > span:nth-child(1),
.see_new_four_hnswzx > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_four_hnswzx > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.see_new_four_hnswzx .detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.see_new_four_hnswzx .detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.see_new_four_hnswzx .detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_four_hnswzx > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_four_hnswzx > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 166px;
  transform: translate(-50%, 0);
}

.see_new_four_hnswzx > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_four_hnswzx > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_four_hnswzx > .QRCode > img {
  width: 65px;
  height: 65px;
  margin: 2px auto;
}
/*鞍山立山证书 */
  .see_new_four_asls {
  width: 470px;
  height: 690px;
  background: url(../../assets/images/common/asls/certificatenew_v4.png) no-repeat;
  /*background-size: cover;*/
  float: left;
  font-size: 12px;
  color: #333;
  position: relative;
  text-align: left;
  margin-top: 32px;
}

.see_new_four_asls > .title {
  width: 100% !important;
  height: 42px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  margin-top: 26px;
  font-weight: normal;
  background: url(../../assets/images/common/certificate-title.png) no-repeat center;
}

.see_new_four_asls > .certificate-number {
  width: 100% !important;
  text-align: center;
  margin-top: 7px;
}

.see_new_four_asls > .introduce {
  width: 420px;
  line-height: 22px;
  margin: 0px auto 0 auto;
  text-indent: 24px;
}

.see_new_four_asls > .abstract {
  width: 420px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

.see_new_four_asls > .abstract > span,
.see_new_four_asls > .detail-line > span {
  float: left;
}

.see_new_four_asls > .abstract > span:nth-child(1),
.see_new_four_asls > .detail-line > span:nth-child(1) {
  width: 89px;
  text-align: right;
}

.see_new_four_asls > .abstract > span:nth-child(2) {
  width: 330px;
  word-wrap: break-word;
  word-break: normal;
}

.see_new_four_asls .detail-line > span:nth-child(2) {
  width: 275px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}


.see_new_four_asls .detail-line:nth-child(1) {
  margin-top: 110px !important;
}

.see_new_four_asls .detail-line:nth-of-type(1) {
  margin-top: 110px !important;
}

.see_new_four_asls > .detail-line {
  width: 420px;
  height: 17px;
  margin: 0 auto;
}

.see_new_four_asls > .issue {
  text-align: center;
  position: absolute;
  left: 50%;
  bottom: 166px;
  transform: translate(-50%, 0);
}

.see_new_four_asls > .issue > p {
  font-size: 12px;
  line-height: 13px;
  margin-top: 5px;
}

.see_new_four_asls > .QRCode {
  width: 66px;
  height: 66px;
  position: absolute;
  bottom: 166px;
  left: 52px;
  background: url(../../assets/images/common/certificate-QRCode.png) no-repeat center;
  padding: 2px;
}

.see_new_four_asls > .QRCode > img {
  width: 65px;
  height: 65px;
  margin: 2px auto;
}
</style>
